import script from "./PLLCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PLLCard.vue?vue&type=script&setup=true&lang=js"

import "./PLLCard.vue?vue&type=style&index=0&id=1c8a61b6&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8a61b6"]])

export default __exports__